module.exports = __webpack_public_path__ + "img/39_68.f669c699.png";